export default {
  title: {
    hmManagement: '招聘经理管理',
    roleManagement: '角色管理',
    hmAdd: '增添招聘经理',
    hmEdit: '编辑招聘经理',
    resetPassword: '重置密码'
  },
  menu: '招聘经理管理',
  label: {
    firstName: '名字',
    lastName: '姓氏',
    company: '公司',
    email: '邮箱地址',
    updateTime: '更新时间',
    status: '状态',
    active: '活跃状态',
    option: '操作',
    companyName: '公司名称',
    addHM: '新增招聘经理',
    editHM: '编辑招聘经理',
    activeMonth: '最近活跃',
    checkAll: '全选',
    resetPassword: '重置密码',
    password: '新密码：',
    confirmPassword: '请再次输入密码：',
    questionnaire: '问卷',
    emailTemplate: '邮件模板',
    oneMonth: '一个月',
    twoMonth: '两个月',
    threeMonth: '三个月',
    fourMonth: '四个月',
    fiveMonth: '五个月',
    sixMonth: '六个月'
  },
  placeholder: {
    firstName: '请输入名字',
    lastName: '请输入姓氏',
    company: '请选择公司',
    email: '请输入邮箱',
    password: '请输入密码',
    confirmPassword: '请再次输入密码',
    questionnaire: '请选择一套问卷',
    emailTemplate: '请选择一套邮件模板'
  },
  btn: {
    addHM: '添加招聘经理',
    survey: '邀请满意度调查',
    resetPassword: '重置密码'

  },
  message: {
    optionSuccess: '操作成功',
    optionField: '操作失败',
    hmRequired: '这是必填项。',
    emailExist: '此邮箱地址已被注册。',
    emailValid: '输入一个有效的 e-mail 地址。',
    confirmPasswordSame: '请确认密码相同',
    resetPasswordError: '24小时内最多重置5次密码，请隔天再试.',
    resetPasswordSuccess: '重置密码邮件已发, 可在几分钟内查收.',
    sendSurvey: '请选择满意度调查问卷和邮件模板',
    checkedLeastOneHm: '至少选择一位招聘经理'
  }
}
